import styled from "styled-components";
import { FaCheck } from 'react-icons/fa'

export const InputButton = styled.button`
background: #377DFF;
border-radius: 0.38em;
height: 3em;
width:100%;
display: grid;
place-content: center;
border: none;
margin-top: ${({login}) => login ? '1em' : '2.2em'};
color: white;
cursor: pointer;

@media(max-width: 428.33px){
    width: 21.9em;
    justify-self: center;
    margin-top: ${({login}) => login ? '0.4em' : '1.5em'};  
}
`
export const CheckBox = styled.div`
height: 1.1em;
width: 1.1em;
background: #377DFF;
color: white;
border-radius: 0.17em;
display: grid;
place-items: center;
cursor: pointer;
transition: 250ms;
svg{
    height: 0.7em;
    width: 0.7em;
    transition:250ms;
}


`

 

export const Check = ({onCheck, id}) => (
    <CheckBox onClick = {onCheck} id = {id}>
        <FaCheck/>
    </CheckBox> 
) 